// SPDX-License-Identifier: MIT

/**
 * Escapes HTML-significant characters for safe interpolation into innerHTML.
 *
 * Used by all v2 components that interpolate user-controlled or i18n strings.
 * NEVER inline user content via innerHTML without this helper.
 */
export function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
